import {Component, Input, OnInit} from '@angular/core';
import {PopoverControllerService} from '../../../../shared/shared-services/overlay/popover-controller.service';
import {IUser} from '../../../../features/user-access/models/user/user';
import {getImageURL} from '../../../../features/core/store/core.actions';
import {selectImageURL} from '../../../../features/core/store/core.selectors';
import {Observable} from 'rxjs';
import {Store} from '@ngrx/store';
import {setGlobalModalVisibility} from '../../../../features/user-access/user-store/user.actions';
import {selectCurrentVersion} from '../../../../features/core/store-shared/shared.selectors';
import {ModalType} from '../../../../features/global-modal-container/models/modal-enums';;
import {setNotificationFilterChips} from '../../../../features/notifications/store/notification.actions';
import {DEFAULT_NOTIFICATIONS_CHIPS} from '../../../../features/notifications/models';
import {setNavigation} from '../../../../features/user-access/user-stores-store/user-store.actions';
import {NavigationPageEnum} from '../../../../features/user-access/models/navigations.enums';
import {settingsSetSelected} from '../../../../features/settings-new/store/setting.actions';
import {SettingsReferenceEnum} from '../../../../features/settings-new/models/general/settings-reference.enum';

@Component({
  selector: 'app-menu-popup',
  templateUrl: './menu-popup.component.html',
  styleUrls: ['./menu-popup.component.scss'],
  standalone: false,
})
export class MenuPopupComponent implements OnInit {

  @Input() user: IUser;
  @Input() pp: string[];

  imageURL$: Observable<string>;
  imageUrl: string;
  versionNumber$: Observable<string>;
  isMobile: boolean;

  constructor(
    private popoverController: PopoverControllerService,
    private readonly store: Store,
  ) {
    this.isMobile = window.innerWidth < 600;
    window.addEventListener('resize', () => {
      this.isMobile = window.innerWidth < 600;
    });
  }

  ngOnInit(): void {
    const image = 'gallix_cloud_flow_chart.svg';
    this.store.dispatch(getImageURL({path: `/site_media/help/data_freshness/${image}`, image}));
    this.imageURL$ = this.store.select(selectImageURL(image));
    this.imageURL$.subscribe((image: string): void => {
      this.imageUrl = image;
    });

    this.versionNumber$ = this.store.select(selectCurrentVersion);
  }

  async onUserProfileClick(): Promise<void> {
    await this.popoverController.dismiss();

    this.store.dispatch(settingsSetSelected.setSelectedReference({ref: SettingsReferenceEnum.accountUserProfile}));
    this.store.dispatch(setNavigation({
      feature: NavigationPageEnum.SettingsNew,
      navigation: {
        currentPage: NavigationPageEnum.SettingsNew,
        currentTab: null,
      },
    }));
  }

  async onSignOutClick(): Promise<void> {
    await this.popoverController.dismiss();
    this.store.dispatch(setGlobalModalVisibility({visibility: true, modalType: [ModalType.SignOut]}));
  }

  async onOpenNotificationsClick(): Promise<void> {
    await this.popoverController.dismiss();
    const filters = {...DEFAULT_NOTIFICATIONS_CHIPS};
    this.store.dispatch(setNotificationFilterChips({filters}));
    this.store.dispatch(setGlobalModalVisibility({visibility: true, modalType: [ModalType.Notifications]}));
  }
}
